import { useEffect, useState } from "react";
import { Disc3 } from "lucide-react";
import { coverUrl } from "@/lib/api";

const TINTS = ["#F2F0E9", "#FEF3C7", "#E7E5E4", "#ECFCCB", "#E0F2FE", "#FCE7F3", "#F5F5F4"];

function tint(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}

export const Cover = ({ albumId, hasCover = true, alt = "", className = "", rounded = "rounded-md", iconSize = 28, version }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [albumId, version]);
  if (!albumId || !hasCover || failed) {
    return (
      <div className={`flex items-center justify-center ${rounded} ${className}`} style={{ background: tint(albumId) }}>
        <Disc3 size={iconSize} strokeWidth={1.25} className="text-zinc-400" />
      </div>
    );
  }
  return (
    <img
      src={version ? `${coverUrl(albumId)}${coverUrl(albumId).includes("?") ? "&" : "?"}v=${version}` : coverUrl(albumId)}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`object-cover ${rounded} ${className}`}
    />
  );
};
